var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7483 10.1243C20.027 10.515 20.1663 10.7105 20.1663 10.9997C20.1663 11.2889 20.027 11.4843 19.7483 11.8751C18.4961 13.6311 15.2981 17.4163 10.9997 17.4163C6.70122 17.4163 3.50327 13.6311 2.25104 11.8751C1.97235 11.4843 1.83301 11.2889 1.83301 10.9997C1.83301 10.7105 1.97235 10.515 2.25104 10.1243C3.50327 8.36833 6.70122 4.58301 10.9997 4.58301C15.2981 4.58301 18.4961 8.36833 19.7483 10.1243Z",
    stroke: "#77787B",
    strokeWidth: 1.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 11C13.75 9.48117 12.5188 8.25 11 8.25C9.48117 8.25 8.25 9.48117 8.25 11C8.25 12.5188 9.48117 13.75 11 13.75C12.5188 13.75 13.75 12.5188 13.75 11Z",
    stroke: "#77787B",
    strokeWidth: 1.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/Eye.7b3666209c7360375582c2147a957d65.svg";
export { ForwardRef as ReactComponent };